export const pipelineRevenueSplitTransformer = response => {
  return response?.data?.timeline
}
